if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const target = document.querySelector('.site-nav__link.site-nav__link--icon.js-drawer-open-cart');
    if (!target) return;

    const observer = new MutationObserver(async (mutations) => {
      for (let mutation of mutations) {
        if (mutation.attributeName === "aria-expanded") {
          const isOpen = target.getAttribute("aria-expanded") === "true";

          if (isOpen) {
            console.log("open mini cart");
            async function handleMiniCart(){
                try {
                fetch(window.Shopify.routes.root + 'cart.js')
                .then(response => response.json())
                .then(data => {
                    const cartDrawer = document.querySelector(".boost-sd__cart.boost-sd__cart--side")
                    if (cartDrawer) {
                    cartDrawer.classList.add("bss-b2b-mini-cart")
                    const cartItems = data.items;
                    if (cartItems.length) {
                        let listCartOrigin = document.querySelectorAll(".boost-sd__cart-item");
                        listCartKey = cartItems.map(cartItem=> cartItem.key);
                        listCartOrigin.forEach((item, i) => {
                        item.setAttribute("bss-b2b-cart-item-key", listCartKey[i]);
                        const itemOrginalPrice = item.querySelector('.boost-sd__cart-item-quantity-price span[role="text"]')

                        itemOrginalPrice.setAttribute("bss-b2b-item-original-price", "");
                        });
                        document.querySelector(".boost-sd__cart-price").setAttribute("bss-b2b-cart-total-price", "");   
                    }
                    }
                });
                
                return true;
                }catch(e) {
                return false;
                }
            }

            setTimeout(async () => {
                await handleMiniCart();
            }, 1000);
            BSS_B2B?.observer?.cartSubject?.notifyObserver?.('CartUpdate', 'CartMutate');
            BSS_B2B?.observer?.cartSubject?.listenCartCheckout?.();

            const checkBtnInterval = setInterval(() => {
                const btn = document.querySelector(".boost-sd__cart-btn-group [type='button']:not(.bss-checkout)");

                if (btn) {
                    clearInterval(checkBtnInterval);

                    const newBtn = btn.cloneNode(true);
                    newBtn.setAttribute("type", "button");
                    btn.parentNode.replaceChild(newBtn, btn);

                    newBtn.addEventListener("click", function (e) {
                    e.preventDefault();
                    console.log("Checkout clicked");
                    BSS_B2B.observer.cartSubject.notifyObserver('CartCheckout', 'ClickCheckout');
                    });

                    console.log("[BSS_B2B] Checkout button event initialized");
                }
                }, 500);

            setTimeout(() => clearInterval(checkBtnInterval), 10000);
          }
        }
      }
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ["aria-expanded"]
    });
  }, 300);
}

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver(async (MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('boost-sd__cart-enabled')) {
            console.log("open mini cart 1");
            async function handleMiniCart(){
                try {
                fetch(window.Shopify.routes.root + 'cart.js')
                .then(response => response.json())
                .then(data => {
                    const cartDrawer = document.querySelector(".boost-sd__cart.boost-sd__cart--side")
                    if (cartDrawer) {
                    cartDrawer.classList.add("bss-b2b-mini-cart")
                    const cartItems = data.items;
                    if (cartItems.length) {
                        let listCartOrigin = document.querySelectorAll(".boost-sd__cart-item");
                        listCartKey = cartItems.map(cartItem=> cartItem.key);
                        listCartOrigin.forEach((item, i) => {
                        item.setAttribute("bss-b2b-cart-item-key", listCartKey[i]);
                        const itemOrginalPrice = item.querySelector('.boost-sd__cart-item-quantity-price span[role="text"]')

                        itemOrginalPrice.setAttribute("bss-b2b-item-original-price", "");
                        });
                        document.querySelector(".boost-sd__cart-price").setAttribute("bss-b2b-cart-total-price", "");   
                    }
                    }
                });
                
                return true;
                }catch(e) {
                return false;
                }
            }

            setTimeout(async () => {
                await handleMiniCart();
            }, 1000);
            BSS_B2B?.observer?.cartSubject?.notifyObserver?.('CartUpdate', 'CartMutate');
            BSS_B2B?.observer?.cartSubject?.listenCartCheckout?.();

            const checkBtnInterval = setInterval(() => {
                const btn = document.querySelector(".boost-sd__cart-btn-group [type='button']:not(.bss-checkout)");

                if (btn) {
                    clearInterval(checkBtnInterval);

                    const newBtn = btn.cloneNode(true);
                    newBtn.setAttribute("type", "button");
                    btn.parentNode.replaceChild(newBtn, btn);

                    newBtn.addEventListener("click", function (e) {
                    e.preventDefault();
                    console.log("Checkout clicked");
                    BSS_B2B.observer.cartSubject.notifyObserver('CartCheckout', 'ClickCheckout');
                    });

                    console.log("[BSS_B2B] Checkout button event initialized");
                }
                }, 500);

            setTimeout(() => clearInterval(checkBtnInterval), 10000);
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
  }

